
import Vue from 'vue';
import Component from 'vue-class-component';
import { Prop } from 'vue-property-decorator';
import { Location } from 'vue-router';
import { IShortUser } from '@/model/shortInterfaces';

@Component({ name: 'UserListSummary' })
export default class UserListSummary extends Vue {
  @Prop({ required: true })
  protected user!: IShortUser;

  protected get displayName(): string {
    return [this.user.first_name, this.user.last_name].filter(Boolean).join(' ').trim()
      || this.user.email || this.user.phone_number || '—';
  }

  protected get toUserDetail(): Location {
    return { name: 'user', params: { userId: '' + this.user.id } };
  }

  protected get originLabel(): string|null {
    const origin = this.user.registration_origin;
    if (!origin || (origin === 'native_app' && this.user.uses_native_app)) return null;
    const key = 'users.userList.origins.' + origin;
    return this.$t(this.$te(key) ? key : 'users.userList.origins.unknown').toString();
  }

  protected get platformLabel(): string|null {
    switch (this.user.native_platform) {
      case 'ios': return 'iOS';
      case 'android': return 'Android';
      case 'both': return 'iOS + Android';
      default: return null;
    }
  }
}
